import { useUser } from '@ctcells/api'

/** 표에 없는 id 한 칸 — `GET /users/{id}`. 못 풀면 id 그대로 */
export function OwnerNameById({ userId }: { userId: string }) {
  const user = useUser({ userId })
  if (user.isSuccess)
    return <span>{user.data.name === '' ? user.data.username : user.data.name}</span>
  return <span className="muted mono">{userId}</span>
}
